import { render, staticRenderFns } from "./PulpitObecne.vue?vue&type=template&id=f5070616&scoped=true&"
import script from "./PulpitObecne.vue?vue&type=script&lang=js&"
export * from "./PulpitObecne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5070616",
  null
  
)

export default component.exports